import { configureStore } from '@reduxjs/toolkit'
import { counterReducer } from '../../../../entities/Counter/'
import { PageContentReducer } from '../../../../entities/PageContent'
import { UserReducer } from '../../../../entities/User'
import { AuthByUsernameReducer } from '../../../../features/AuthByUsername/model/slices/AuthByUsernameSlice'
import $api from '../../../../shared/api/api'
import { StateSchema } from './StateSchema'

export function createReduxStore(initialState?: StateSchema) {
    return configureStore({
        reducer: {
            counter: counterReducer,
            user: UserReducer,
            authByUsername: AuthByUsernameReducer,
            pageContent: PageContentReducer
        },
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: {
                    extraArgument: {
                        api: $api
                    }
                }
            })
    })
}

export type AppDispatch = ReturnType<typeof createReduxStore>['dispatch']
